import useSWR from 'swr';
import { fetcher } from '../../services/fetcher';

const API_LIST = '/recurring-payables';
const API_DETAIL = (id: number) => `/recurring-payables/${id}`;

export interface RecurringPayable {
  id: number;
  payeeId?: number;
  payeeName: string;
  amount: number;
  recurrenceIntervalId?: number;
  dayOfMonth?: number;
  startDate?: string | null;
  categoryId?: number;
  subCategoryId?: number;
  notes?: string;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
  createdById?: number;
  updatedById?: number;
  recurrenceInterval?: { id: number; tri_descr: string; months: number };
  categoryDescr?: { id: number; name: string };
  subCategoryDescr?: { id: number; name: string };
  createdBy?: { userFirstName: string };
  updatedBy?: { userFirstName: string };
}

export const useRecurringPayables = (searchParams?: string) => {
  const query = searchParams ? `?searchParams=${encodeURIComponent(searchParams)}` : '';
  const { data, error, isLoading, mutate } = useSWR<RecurringPayable[]>(`${API_LIST}${query}`, fetcher, {
    revalidateOnFocus: true,
  });
  const records = Array.isArray(data) ? data : [];
  return { data: records, isLoading, isError: !!error, mutate };
};

export const useRecurringPayable = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<RecurringPayable>(id ? API_DETAIL(id) : null, fetcher, {
    revalidateOnFocus: true,
  });
  return { data, isLoading, isError: !!error, mutate };
};

export const useRecurrenceIntervals = () => {
  const { data, error, isLoading } = useSWR<Array<{ id: number; tri_descr: string; months: number }>>(
    '/p-crm-todo-recurrence-interval',
    fetcher
  );
  const options = (data || []).map((r) => ({ value: String(r.id), label: r.tri_descr }));
  return { options, isLoading, isError: !!error };
};

export const useExpenseCategoriesForRecurring = () => {
  const { data } = useSWR<any[]>('/crm-expense-category', fetcher);
  const options = (data || []).map((c) => ({ value: String(c.id), label: c.name }));
  return { options };
};
